import { gql } from "@apollo/client";

export const GET_ORDERS_IDS_BY_EVENTID = gql`
  query Orders($eventId: String) {
    orders(eventId: $eventId) {
      id
      status
    }
  }
`;

export const GET_ORDERSV3_BY_EVENTID = gql`
  query OrdersV3(
    $pagination: Pagination
    $orderIdOrSeriesSearchTerm: String
    $createdFrom: DateTime
    $createdTo: DateTime
    $metadataUserSearchTerm: String
    $statuses: [OrderStatus!]
    $companyIds: [String!]
    $eventIds: [String!]
    $boughtVia: [String!]
  ) {
    ordersV3(
      pagination: $pagination
      orderIdOrSeriesSearchTerm: $orderIdOrSeriesSearchTerm
      createdFrom: $createdFrom
      createdTo: $createdTo
      metadataUserSearchTerm: $metadataUserSearchTerm
      statuses: $statuses
      companyIds: $companyIds
      eventIds: $eventIds
      boughtVia: $boughtVia
    ) {
      items {
        id
        createdAt
        price
        status
        invoicingStatus
        discount
        commission
        platformPayCommission
        boughtVia
        user {
          lastName
          firstName
          account {
            email
            phone
          }
        }
        items {
          id
          name
          type
          seatIds
          createdAt
          price
          itemPrice
          quantity
          ticketType {
            name
            id
            price
          }
          tickets {
            status
            series
            id
            documentLightUrl
          }
          promoCode {
            percent
            name
            id
          }
          questionnaireAnswers {
            value
            question {
              id
              title
              description
              type
              options
              order
            }
          }
        }
        metadata
        event {
          name
          company {
            companyInfo {
              companyName
            }
          }
          currency
        }
      }
      totalCount
    }
  }
`;

export const GET_BOOKING_ORDER_ITEMS = gql`
  query GetBookingOrderItems($reservationId: ID!) {
  getBookingOrderItems(reservationId: $reservationId) {
    id
    price
    discount
    commission
    platformPayCommission
    items {
      id
      itemPrice
      name
      quantity
      type
    }
  }
}
`;

export const GET_USER_ORDER_ITEMS = gql`
  query GetActivityOrderItems($eventId: ID!, $reservationId: ID) {
  getActivityOrderItems(eventId: $eventId, reservationId: $reservationId) {
    id
    price
    items {
      id
      itemPrice
      name
      quantity
      type
    }
    event {
      currency
    }
  }
}
`;
